import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateTeam=({id,leagueId,name},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_TEAM_START
    })
    const options={
        url:`${api}/teams/${id}`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{id,leagueId,name}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_TEAM_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_TEAM_FAIL,
                payload:getMessage(error)
            }))
}